import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const AppSettingsCustomAttributesDataApiDataTable = lazy(() =>
  import("@components/AppSettingsCustomAttributesDataApiDataTable").then((module) => ({
    default: module.AppSettingsCustomAttributesDataApiDataTable,
  }))
);

export const customAttributesNRO: NavigationRoutingObject = {
  Component: AppSettingsCustomAttributesDataApiDataTable,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("custom-user-attributes-menu-option", "Custom Attributes"),
  pageNameForTracking: () => "Custom Attributes",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("custom-user-attributes-description-nav", "Manage the custom attributes you collect from your users"),
  icon: "nav-system-custom-attributes",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
